// @flow
import { ProductosActionTypes } from './constants';

type ProductosAction = { type: string, payload: {} | string };

// common success
export const productosApiResponseSuccess = (actionType: string, data: any): ProductosAction => ({
    type: ProductosActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const productosApiResponseError = (actionType: string, error: string): ProductosAction => ({
    type: ProductosActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getProducto = (id: string): ProductosAction => ({
    type: ProductosActionTypes.GET_PRODUCTO,
    payload: { id },
});

export const listProductos = (): ProductosAction => ({
    type: ProductosActionTypes.LIST_PRODUCTOS,
    payload: {},
});

export const syncProductos = (): ProductosAction => ({
    type:ProductosActionTypes.SYNC_PRODUCTOS,
    payload:{}
})

export const resetProductos = (): ProductosAction => ({
    type: ProductosActionTypes.RESET,
    payload: {},
});

